import jwt from 'jsonwebtoken'

import useAccount from '@/common/composable/useAccount'

const SCRIPT_SRC = 'https://chat-api.spartez-software.com/chat-widget.js'
const AUTO_LOGIN_SECRET = 'MTUwLDIxOSwxMjksOCw2NCwxMjIsOTUsMjU0LDc3LDIwNiwzNywyNDcsNjgsNzAsNDksMTA2'
const TARGET_ENDPOINT_URL = 'https://chat-api.spartez-software.com/chat/'
const TARGET_ENDPOINT_METHOD = 'POST'

const WORKING_HOURS_MIN = 9
const WORKING_HOURS_MIN_STRING = '09:00'
const WORKING_HOURS_MAX = 20
const WORKING_HOURS_MAX_STRING = '20:00'

export default function () {
    const { state } = useAccount()

    const createToken = async (): Promise<string> => {
        const email = state.user_email
        const displayName = state.user_name

        const token = await jwt.sign({
            email,
            displayName,
        }, AUTO_LOGIN_SECRET, { algorithm: 'HS256' })

        return token
    }

    const isOutsideWorkingHours = (): boolean => {
        const now = new Date()
        const currentHour = now.getHours()

        if (currentHour < WORKING_HOURS_MIN || currentHour >= WORKING_HOURS_MAX) {
            return true
        }

        return false
    }

    const redefineAdapter = () => {
        (function() {
            const originalOpen = XMLHttpRequest.prototype.open
            const originalSend = XMLHttpRequest.prototype.send
            
            XMLHttpRequest.prototype.open = function(method: string, url: string, async?: boolean, username?: string | null, password?: string | null) {
                if (url.includes(TARGET_ENDPOINT_URL) && method === TARGET_ENDPOINT_METHOD) {
                    // @ts-ignore
                    this.isTargetRequest = true
                }
                
                // @ts-ignore
                return originalOpen.apply(this, [method, url, async, username, password]);
            }
            
            XMLHttpRequest.prototype.send = function(body) {
                // @ts-ignore
                if (this.isTargetRequest) {
                    if (isOutsideWorkingHours()) {
                        alert(`Благодарим вас за обращение. Наш контакт центр работает ежедневно с ${WORKING_HOURS_MIN_STRING} до ${WORKING_HOURS_MAX_STRING}, без выходных и перерывов. Вам обязательно ответят в рабочее время.`)
                    }
                }

                return originalSend.apply(this, [body])
            }
        })()
    }

    const onScriptLoad = async () => {
        const chatWidget  = document.querySelector('chat-widget')
        if (!chatWidget) return

        // @ts-ignore
        chatWidget.onload = async function () {
            redefineAdapter()

            const token = await createToken()
            // @ts-ignore
            await chatWidget.loginWithToken(token)
        }
    }

    const install = () => {
        const script = document.createElement('script')
        script.id = 'jira-widget'
        script.src = SCRIPT_SRC

        script.onerror = (error) => {
            console.error('Jira widget script install error')
            console.error(error)
        }

        document.head.append(script)
        onScriptLoad()
    }

    const destroy = () => {
        const script = document.head.querySelector('script#jira-widget')
        if (!script) return
        script.remove()
    }

    return { install, destroy }
}